
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ShipmentEcommerceType } from '@/features/shipment/types';

@Component
export default class EcommerceInfo extends Vue {
  @Prop({ required: true }) ecommerceData!: ShipmentEcommerceType;
}
